import {
  FETCH_DISPATCH,
  CREATE_DISPATCH,
  DELETE_DISPATCH,
  UPDATE_DISPATCH,
  COPY_ITEM,
  UPDATE_TEAM_JOB,
  COPY_DISPATCHES,
  REORDER_DISPATCHES,
  REORDER_JOBS,
  CHANGE_DATE,
  ADD_COPY_TEAMS,
  COPY_ALL_TEAMS,
  PASTE_TEAMS,
  DELETE_JOBS,
  ADD_JOBS,
  UPDATE_TEAMS_VISIBILITY,
} from "./constants";

// const array_move = (arr, old_index, new_index) => {
//   if (new_index >= arr.length) {
//     var k = new_index - arr.length + 1;
//     while (k--) {
//       arr.push(undefined);
//     }
//   }
//   arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
//   return arr;
// };

export default function createDispatchReducer() {
  const initialState = {
    teams: {},
    teamJobs: {},
    copyType: "",
    copyPayload: null,
    dispatchCopyPayload: [],
    employees: {},
    toolboxes: {},
    trucks: {},
    jobs: {},
  };

  function fetchDispatch(state, action) {
    // we need to iterate on the data
    // so split data into 2 parts
    return { ...state, ...action.payload };
  }

  function copyItem(state, action) {
    const { copyType, copyPayload, fromTeamID } = action.payload;
    return {
      ...state,
      copyType,
      copyPayload,
      fromTeamID,
    };
  }

  function createDispatch(state, action) {
    const newTeam = action.payload.team;
    const { teamJobs } = action.payload;

    const newsTeams = {};

    if (newTeam.length) {
      newTeam.forEach((team) => {
        newsTeams[team.id] = team;
      });
    }

    return {
      ...state,
      copyType: "",
      copyPayload: null,
      teams: { ...state.teams, ...newsTeams },
      teamJobs: { ...state.teamJobs, ...teamJobs },
    };
  }

  function deleteDispatch(state, action) {
    const { id } = action.payload;
    const deletedTeam = state.teams[id];
    const keys = Object.keys(state.teams).filter(
      (key) => Number.parseInt(key, 10) !== action.payload.id
    );

    const newTeams = keys.reduce((acc, key) => {
      acc[key] = state.teams[key];
      if (state.teams[key].index > deletedTeam.index) {
        acc[key].index -= 1;
      }
      return acc;
    }, {});

    return { ...state, teams: newTeams };
  }

  function updateDispatch(state, action) {
    const { teamJobs, team } = action.payload;

    if (!teamJobs) {
      return {
        ...state,
        teams: {
          ...state.teams,
          [team.id]: { ...team },
        },
      };
    }

    return {
      ...state,
      teams: {
        ...state.teams,
        [team.id]: { ...team },
      },
      teamJobs: {
        ...state.teamJobs,
        ...teamJobs,
      },
    };
  }

  function updateTeamJob(state, action) {
    const { job } = action.payload;
    return {
      ...state,
      teamJobs: {
        ...state.teamJobs,
        [job.id]: { ...state.teamJobs[job.id], ...job },
      },
    };
  }

  function copyDispatches(state, action) {
    const { arrayOfJobs } = action.payload;
    return { ...state, dispatchCopyPayload: arrayOfJobs };
  }

  function reorderDispatches(state, action) {
    const { startIndex, endIndex, teamID } = action.payload;
    let { teams } = state;
    const newTeams = { ...teams };

    teams = Object.values(teams);

    if (startIndex < endIndex) {
      teams.forEach((t) => {
        if (t.index <= endIndex && t.index > startIndex) {
          newTeams[t.id].index -= 1;
        }
      });
    } else {
      teams.forEach((t) => {
        if (t.index >= endIndex && t.index < startIndex) {
          newTeams[t.id].index += 1;
        }
      });
    }

    newTeams[teamID].index = endIndex;
    return { ...state, teams: newTeams };

    // const { startIndex, endIndex } = action.payload;
    // const { teams } = state;
    // let newTeams = { ...teams };

    // // find moved team
    // let team;
    // Object.keys(teams).forEach(key => {
    //   if (teams[key].index === startIndex) {
    //     team = teams[key];
    //   }
    // });

    // // Operation if moved forward or back
    // if (startIndex === endIndex) {
    //   return state;
    // } else if (startIndex < endIndex) {
    //   Object.keys(teams).forEach(key => {
    //     // Increment every value inside
    //     if (startIndex < teams[key].index && teams[key].index <= endIndex) {
    //       newTeams[key].index -= 1;
    //     }
    //   });
    //   newTeams[team.id].index = endIndex;
    // } else {
    //   Object.keys(teams).forEach(key => {
    //     if (endIndex <= teams[key].index && teams[key].index < startIndex) {
    //       newTeams[key].index += 1;
    //     }
    //   });

    //   newTeams[team.id].index = endIndex;
    // }
    // return { ...state, teams: newTeams };
  }

  function reorderJobs(state, action) {
    const { startIndex, endIndex, teamID, jobID } = action.payload;
    const { teamJobs, teams } = state;
    const { jobs } = teams[teamID];
    const newTeamJobs = { ...teamJobs };

    if (startIndex > endIndex) {
      jobs.forEach((j) => {
        const job = newTeamJobs[j];
        if (job.index >= endIndex && job.index < startIndex) {
          newTeamJobs[j].index += 1;
        }
      });
    } else {
      jobs.forEach((j) => {
        const job = teamJobs[j];
        if (job.index <= endIndex && job.index > startIndex) {
          newTeamJobs[j].index -= 1;
        }
      });
    }

    newTeamJobs[jobID].index = endIndex;

    // array_move(teams[teamID].jobs, startIndex, endIndex);

    return { ...state, teamJobs: { ...newTeamJobs } };
  }

  function changeDate(state, action) {
    return { ...state, date: action.payload.date };
  }

  function copyAllTeams(state) {
    return {
      ...state,
      copyType: "teams",
      copyPayload: state.teams,
    };
  }

  function addCopyTeams(state, action) {
    if (state.copyType === "teams") {
      if (state.copyPayload[action.payload.team.id]) {
        const newCopyPayload = { ...state.copyPayload };
        delete newCopyPayload[action.payload.team.id];
        return { ...state, copyPayload: newCopyPayload };
      }
      return {
        ...state,
        copyPayload: {
          ...state.copyPayload,
          [action.payload.team.id]: action.payload.team,
        },
      };
    }
    return {
      ...state,
      copyType: "teams",
      copyPayload: { [action.payload.team.id]: action.payload.team },
    };
  }

  function pasteTeams(state, action) {
    const { teamJobs, teams } = action.payload;

    return {
      ...state,
      teams: {
        ...state.teams,
        ...teams,
      },
      copyType: "",
      copyPayload: null,
      teamJobs: {
        ...state.teamJobs,
        ...teamJobs,
      },
    };
  }

  function addJobs(state, action) {
    const { teamID, jobsToAdd, tmp_jobs_ids } = action.payload;
    const newTeamJobs = {};
    const jobs = [];

    jobsToAdd.forEach((job) => {
      newTeamJobs[job.id] = job;
      jobs.push(job.id);
    });

    const team = state.teams[teamID];
    return {
      ...state,
      teams: {
        ...state.teams,
        [teamID]: {
          ...team,
          jobs: [...team.jobs, ...jobs],
          tmp_jobs_ids: [...team.tmp_jobs_ids, ...tmp_jobs_ids],
        },
      },
      teamJobs: { ...state.teamJobs, ...newTeamJobs },
    };
  }

  function deleteJobs(state, action) {
    const { teamID, jobsToRemove } = action.payload;
    const jobs = state.teams[teamID].jobs.filter((jobID) => {
      if (jobsToRemove.includes(jobID)) {
        return false;
      }
      return true;
    });

    return {
      ...state,
      teams: {
        ...state.teams,
        [teamID]: { ...state.teams[teamID], jobs },
      },
    };
  }

  function updateTeamsVisibility(state, action) {
    const { visible } = action.payload;

    const teams = {};

    Object.keys(state.teams).map((key) => {
      teams[key] = { ...state.teams[key], visible };
    });

    return {
      ...state,
      teams: teams,
    };
  }

  return function DispatchReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_DISPATCH:
        return fetchDispatch(state, action);
      case CREATE_DISPATCH:
        return createDispatch(state, action);
      case DELETE_DISPATCH:
        return deleteDispatch(state, action);
      case UPDATE_DISPATCH:
        return updateDispatch(state, action);
      case COPY_ITEM:
        return copyItem(state, action);
      case UPDATE_TEAM_JOB:
        return updateTeamJob(state, action);
      case COPY_DISPATCHES:
        return copyDispatches(state, action);
      case REORDER_DISPATCHES:
        return reorderDispatches(state, action);
      case REORDER_JOBS:
        return reorderJobs(state, action);
      case CHANGE_DATE:
        return changeDate(state, action);
      case PASTE_TEAMS:
        return pasteTeams(state, action);
      case COPY_ALL_TEAMS:
        return copyAllTeams(state, action);
      case ADD_COPY_TEAMS:
        return addCopyTeams(state, action);
      case ADD_JOBS:
        return addJobs(state, action);
      case DELETE_JOBS:
        return deleteJobs(state, action);
      case UPDATE_TEAMS_VISIBILITY:
        return updateTeamsVisibility(state, action);
      case "LOGOUT":
        return initialState;
      default:
        return state;
    }
  };
}
